/**
 * Stub for the in-progress device context UI.
 *
 * The real implementation hasn't landed yet — `LitePanel` already renders this
 * component, so this stub returns null to keep the build green. When the
 * feature is finished, replace this file with the real implementation.
 */

import type { AssetContext } from '@/hooks/useAssetContext'

interface DeviceContextCardProps {
  assetContext: AssetContext | null
  loading: boolean
  isDark: boolean
}

export function DeviceContextCard(_props: DeviceContextCardProps) {
  return null
}
